export const TARGET_RECEIVERS = ['S2633001I', 'Q2669003B', 'G26325936', 'S2600005I', 'G26466748', 'A26155135', 'G26348367', 'Q2600395D', 'G67785485', 'Q7650001F', 'P7690002F']

export const FICHA_TERCEROS_URL = 'https://ias1.larioja.org/sicap/terceros-ficha/LoginServlet?c=1'

export const FICHA_TERCEROS_URLS = {
  ADER: 'https://ias1.larioja.org/sicap/terceros-ficha/index.jsp?c=2',
  CEIS: 'https://ias1.larioja.org/sicap/terceros-ficha/index.jsp?c=20',
  CAR: FICHA_TERCEROS_URL
}

const RECEIVER_FICHA_TERCEROS_URL_MAP = {
  'Q7650001F': FICHA_TERCEROS_URLS.ADER,
  'P7690002F': FICHA_TERCEROS_URLS.CEIS
}

export const getFichaTercerosUrl = (nif) => {
  return RECEIVER_FICHA_TERCEROS_URL_MAP[nif?.toUpperCase()] || FICHA_TERCEROS_URLS.CAR
}

export const isTargetReceiver = (nif) => {
    return TARGET_RECEIVERS.includes(nif?.toUpperCase())
}

export const NIF_CODIGO_MAP = {
    'S2633001I': 'FAE_01',
    'Q7650001F': 'FAE_02',
    'P7690002F': 'FAE_20'
}

export const getCodigo = (nif) => {
    return NIF_CODIGO_MAP[nif?.toUpperCase()] || 'FAE_01'
}

export const FIXED_PARAMS = {
    codigo: 'FAE_01',
    usuario: 'SICAPWEB_E',
    pass: 'pi9yduke3i',
    idSistemaOrigen: ''
}
